export default __webpack_public_path__ + "files/FP9_Grants.docx";